// src/components/FrameworkHeader.js
import React from "react";
import { Box, Typography, Tooltip, IconButton } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export default function FrameworkHeader({ title, tooltip }) {
  return (
    <Box display="flex" alignItems="center" mb={0.5}>
      <Typography variant="subtitle1" sx={{ mr: 1 }}>
        {title}
      </Typography>

      <Tooltip
        title={
          <Typography sx={{ fontSize: 16, lineHeight: 1.5 }}>
            {tooltip}
          </Typography>
        }
        componentsProps={{
          tooltip: {
            sx: { maxWidth: 380, padding: 2 },
          },
        }}
      >
        <IconButton size="small" sx={{ color: "black", p: 0.5 }}>
          <InfoOutlinedIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  );
}
